import MediumEditor from 'medium-editor';

const { extensions } = MediumEditor;

const buttonsDefault = extensions.button.prototype.defaults;
Object.keys(buttonsDefault).forEach(key => {
  const button = {};

  /* eslint-disable-next-line default-case */
  switch (key) {
    case 'bold':
      button.aria = 'Жирный';
      button.contentDefault = 'Ж';
      break;
    case 'italic':
      button.aria = 'Курсив';
      button.contentDefault = 'К';
      break;
    case 'underline':
      button.aria = 'Подчёркнутый';
      break;
    case 'strikethrough':
      button.aria = 'Зачёркнутый';
      break;
    case 'superscript':
      button.aria = 'Верхний индекс';
      break;
    case 'subscript':
      button.aria = 'Нижний индекс';
      break;
    case 'image':
      button.aria = 'Изображение';
      break;
    case 'html':
      button.aria = 'Html';
      break;
    case 'orderedlist':
      button.aria = 'Упорядоченный спиок';
      break;
    case 'unorderedlist':
      button.aria = 'Неупорядоченный спиок';
      break;
    case 'indent':
      button.aria = 'Сдвинуть вправо';
      break;
    case 'outdent':
      button.aria = 'Сдвинуть влево';
      break;
    case 'justifyCenter':
      button.aria = 'По центру';
      break;
    case 'justifyFull':
      button.aria = 'По ширине';
      break;
    case 'justifyLeft':
      button.aria = 'По левому краю';
      break;
    case 'justifyRight':
      button.aria = 'По правому краю';
      break;
    case 'removeFormat':
      button.aria = 'Очистить форматирование';
      button.contentDefault = '&times;';
      break;
    case 'quote':
      button.aria = 'Цитата';
      break;
    case 'pre':
      button.aria = 'Преформатирование';
      break;
    case 'h1':
      button.aria = 'Заголовок 1';
      button.contentDefault = 'З<sub>1</sub>';
      break;
    case 'h2':
      button.aria = 'Заголовок 2';
      button.contentDefault = 'З<sub>2</sub>';
      break;
    case 'h3':
      button.aria = 'Заголовок';
      button.contentDefault = 'Тт';
      break;
    case 'h4':
      button.aria = 'Заголовок 4';
      button.contentDefault = 'З<sub>4</sub>';
      break;
    case 'h5':
      button.aria = 'Заголовок 5';
      button.contentDefault = 'З<sub>5</sub>';
      break;
    case 'h6':
      button.aria = 'Заголовок 6';
      button.contentDefault = 'З<sub>6</sub>';
      break;
  }

  Object.assign(buttonsDefault[key], button);
});

Object.assign(extensions.anchor.prototype, {
  aria: 'Ссылка',
  contentDefault: '#',
  placeholderText: 'Вставьте ссылку',
  targetCheckbox: true,
  targetCheckboxText: 'Открыть в новой вкладке',
});

Object.assign(extensions.fontName.prototype, {
  aria: 'Шрифт',
  fonts: ['Fira Sans', 'Tahoma', 'sans-serif'],
});

Object.assign(extensions.fontSize.prototype, {
  aria: 'Размер шрифта',
  // contentDefault: 'Тт',
});

Object.assign(extensions.placeholder.prototype, {
  text: 'Введите текст',
});


export default MediumEditor;
